export enum SlideLayoutEnum {
    BOTTOM_ALIGNED_DESCRIPTION = "Bottom Aligned Description",
    TOP_ALIGNED_DESCRIPTION = "Top Aligned Description",
    RIGHT_ALIGNED_DESCRIPTION = "Right Aligned Description"

}